import { useParams } from "react-router-dom";
import { lazy, Suspense } from "react";

const slots: Record<string, React.LazyExoticComponent<React.ComponentType>> = {
  "1": lazy(() => import("./slot-1")),
  "2": lazy(() => import("./slot-2")),
  "3": lazy(() => import("./slot-3")),
  "4": lazy(() => import("./slot-4")),
  "5": lazy(() => import("./slot-5")),
  "6": lazy(() => import("./slot-6")),
  "7": lazy(() => import("./slot-7")),
  "8": lazy(() => import("./slot-8")),
  "9": lazy(() => import("./slot-9")),
  "10": lazy(() => import("./slot-10")),
  "11": lazy(() => import("./slot-11")),
  "12": lazy(() => import("./slot-12")),
  "18": lazy(() => import("./slot-18")),
  "19": lazy(() => import("./slot-19")),
  "20": lazy(() => import("./slot-20")),
  "30": lazy(() => import("./slot-30")),
  "31": lazy(() => import("./slot-31")),
  "32": lazy(() => import("./slot-32")),
};

export function PlaygroundRouter() {
  const { slot } = useParams<{ slot: string }>();
  const SlotComponent = slot ? slots[slot] : null;

  if (!SlotComponent) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-muted-foreground">
          Playground slot &quot;{slot ?? "?"}&quot; not found.
          {Object.keys(slots).length > 0
            ? ` Available: ${Object.keys(slots).join(", ")}`
            : " No active playgrounds."}
        </p>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-screen">
          <p className="text-muted-foreground">Loading playground...</p>
        </div>
      }
    >
      <SlotComponent />
    </Suspense>
  );
}
